import React from 'react';
import {useIntl} from 'react-intl';
import {LiteEmptyPage} from './LiteEmptyPage';

export const LiteDesignPage = () => {
  const intl = useIntl();
  return (
    <LiteEmptyPage>
      <h5>{intl.formatMessage({id: 'studioLite.design.header'})}</h5>
      <p>{intl.formatMessage({id: 'studioLite.design.1'})}</p>
      <p>
        {intl.formatMessage(
          {id: 'studioLite.design.2'},
          {
            learnLink: (
              <a
                href="https://www.blaize.com/products/ai-studio/#projects"
                target="_blank"
                rel="noreferrer"
              >
                here
              </a>
            ),
          }
        )}
      </p>
    </LiteEmptyPage>
  );
};
